ModalQuickShop = function() {
    var variantArray = [];
	var currentProduct;
	var currentVariant;
	var slickCheck = false;
	var thumbnailLength = 1;
	var storedColourVariantInfo = {};
	var hasColourVariantImages = false;
	var options = {
		showWhitespaceAtEdges: true,
		zoomFactor: 3,
		paneContainer: document.querySelector("#hover-zoom")
	};

	var largeImageSlickSettings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '#thumbnailContainer',
		arrows: false,
		variableWidth: true,
		infinite: false,
		draggable: false
	};

	var thumbnailSlickSettings = {
		slidesToScroll: 1,
		asNavFor: '#variant-large-image-container',
		dots: false,
		arrows: false,
		centerMode: false,
		focusOnSelect: true,
		variableWidth: true,
		infinite: false,
		draggable: false
	};

	var variantPriceRange = false;
	var priceDiff = false;
	var currentProductPrice = 0;
	var prevProductPrice = 0;
	var smallestPrice = 0;
	var compareAtPrice = 0;
	var variantAvailable = false;

	var allProductNamesArr = [];

	function formatMoney(price) {
		var number = (price / 100.0).toFixed(2);
		var parts = number.split('.');
		var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ",");
		var centsAmount = parts[1] ? ("." + parts[1]) : '';
		return dollarsAmount + centsAmount;
	}

	function showAvaialbleVariants(p) {
		var Shopify = Shopify || {};
		Shopify.arrayIncludes = function (e, t) {
			for (var n = 0; n < e.length; n++)
				if (e[n] == t)
					return !0;
			return !1
		};
	}

	//outs the specific variant id so the right one gets added to the cart
	function outputVariantId(variants) {
		for (var k = 0; k < variants.length; k++) {
			$("#quick-shop-variant-ids").append(
				"<option value='" + variants[k].id + "' data-variant-name='" + variants[k].title + "'>" + variants[k].title + "</option>"
			);
		}
	}



	//output the options for the variants in a dropdown select
	function outputOptionTags(obj) {
		var buildHTML = '';
		var valueCounter = 1;
		var optionCounter = 1;

		for (var i = 0; i < obj.length; i++) {
			var currentObj = obj[i];
			if (currentObj.name !== 'Title') {
				var optionName = currentObj.name;
				var optionNameLowercase = currentObj.name.toLowerCase();

				buildHTML += "<div class='variant-selector-wrapper selector-" + optionNameLowercase + "'><div class='variant-option-label'><p class='variant-label'>" + optionName + ":</p></div><div class='selector-wrapper js'>";

				for (var j = 0; j < (currentObj.values).length; j++) {
					var value = currentObj.values[j];

					buildHTML += "<div id='SingleOptionSelector-" + valueCounter + " " + optionName + "' data-option-value='" + value + "' data-index='option" + optionCounter + "' class='variant-selector-radio'><input type='radio' value='" + value + "' data-single-option-selector data-index='option" + optionCounter + "' id='" + optionNameLowercase + "-option" + valueCounter + "' class='select-wide-border' name='" + optionNameLowercase + "'/><label for='" + optionNameLowercase + "-option" + valueCounter + "'>" + value + "</label></div>";

					valueCounter++;
				}

				buildHTML += ("</div></div>");
			}
			optionCounter++;
		}

		$("#quick-shop-options").append(buildHTML);


		$(".selector-wrapper").each(function () {
			$(this).find('.variant-selector-radio').sort(function (a, b) {
					return +a.getAttribute('data-option-value') - +b.getAttribute('data-option-value');
				})
				.appendTo($(this));
		});


	}

	function disableUnavailableOptions(obj) {
		var availableOption1 = [];
		var availableOption2 = [];

		for (var i = 0; i < obj.variants.length; i++) {
			//console.log(obj.variants[i]);
			var option1 = obj.variants[i].option1;
			var option2 = obj.variants[i].option2;

			if (obj.variants[i].available) {
				availableOption1.push(obj.variants[i].option1);
				availableOption2.push(obj.variants[i].option2);
			}
		}

		var allOptions = availableOption1.concat(availableOption2);

		$(".variant-selector-radio input").each(function () {

			var currentInputVal = $(this).val();

			if ($.inArray(currentInputVal, allOptions) !== -1) {
				$(this).prop('disabled', false);
			} else {
				$(this).prop('disabled', true);
			}
		});

		var sizeCheck = $("#size-check").text();

		$(".variant-selector-radio input").each(function () {
			var currentSize = "-" + $(this).val() + "-";
			if (sizeCheck.indexOf(currentSize) >= 0 && $(this).is(':disabled')) {
				$(this).css("display", "none");
				$(this).parent().css("display", "none");
			}
		});

		$(".variant-selector-radio input").change(function () {
			var selectedOption = $(this).val();
			var variantOptionCategory = $(this).attr("data-index");

			var oppositeOption = '';
			var checkAvailableOption = '';

			availableOption2 = [];
			availableOption1 = [];

			$(obj.variants).each(function () {

				if (this.option1 == selectedOption && this.available) {
					availableOption2.push(this.option2);
					oppositeOption = 'option2';
					checkAvailableOption = availableOption2;
				} else if (this.option2 == selectedOption && this.available) {
					availableOption1.push(this.option1);
					oppositeOption = 'option1';
					checkAvailableOption = availableOption1;
				}

			});

			if (variantOptionCategory == 'option2') {


				$(".variant-selector-radio[data-index='" + oppositeOption + "'] input").each(function () {

					var currentInputVal = $(this).val();

					if ($.inArray(currentInputVal, checkAvailableOption) !== -1) {
						$(this).prop('disabled', false);
					} else {
						$(this).prop({
							'disabled': true,
							'checked': false
						});
					}
				});
			}
		});
	}

	//formats the price
	function setPrice(p) {
		var price = '';
		var onSale = '';

		if (p.price < p.compare_at_price) {
			price = '<s>$' + formatMoney(p.compare_at_price) + '</s>';
			onSale = '$' + formatMoney(p.price);
			$("#quick-shop-on-sale").text(onSale);
		} else {
			if(p.price_max && p.price_max > 0) { 
				price = '$' + formatMoney(p.price_max);
			} else {
				price = '$' + formatMoney(p.price);
			}
			$("#quick-shop-on-sale").text('');
		}

		return price;
	}

	function switchColourNames() {
		$("#quick-shop-colour-variants").on("mouseenter", "a", function() {
			$(".variant-selected-color-name").text($(this).data("colorName"));
		});

		$("#quick-shop-colour-variants").on("mouseleave", "a", function() {
			var currentColour = $("#quick-shop-colour-variants").find(".selected").data("colorName");
			$(".variant-selected-color-name").text(currentColour);
		});
    
    }

    function getProdHex(tags) {
      for(var i = 0; i < tags.length; i++) {
        if(tags[i].indexOf("#") > -1) {
          return tags[i];
        }
      }
    }

    function getProdColourName(tags, title) {
      for(var i = 0; i < tags.length; i++) {
        if(tags[i].indexOf("Colour:") > -1) {
          var colour = tags[i].replace("Colour:", "").trim().toLowerCase();
          var prodTitle = title.toLowerCase();
          if(prodTitle.indexOf(colour) > -1) {
            return colour.toUpperCase();
          }
        }
      }
    }

	function buildModalInfo(p) {
		$('#variant-large-image-container').css("opacity", 0);

		currentProduct = p;

		var pColourHandle = p.handle;

		storedColourVariantInfo[p.handle] = p;


		//set the main image
		if (p.featured_image !== null) {
			$("#quick-shop-main-image").attr({
				'src': p.featured_image,
				'data-zoom': p.featured_image
			}).css('opacity', '0');
		}

		$("#variant-large-image-container").empty();


		for (var i = 0; i < p.images.length; i++) {
			$("#thumbnailContainer").append("<img src='" + p.images[i] + "' data-colour='' alt='' class='variant-image-thumb' />");


			$("#variant-large-image-container").append("<img src='" + p.images[i] + "' alt='' data-zoom='" + p.images[i] + "'/>");
		}


		for (var m = 0; m < 10; m++) {
			$("#Quantity").append("<option value=" + (m + 1) + ">" + (m + 1) + "</option>");
		}

		$("#Quantity").val($("#Quantity option:first").val());

		var pTags = p.tags;
		var pColour = [];
		var pTitle = '';
		var pSelectedColour = '';

		for (var j = 0; j < p.tags.length; j++) {
			if ((p.tags[j]).toLowerCase().indexOf("colour:") >= 0) {
				pColour.push(p.tags[j].toLowerCase().replace("colour: ", ""))
			}
		}

		var pColourFormatted = '';
		for (var k = 0; k < pColour.length; k++) {
			if ((p.title).toLowerCase().includes(pColour[k])) {
				pSelectedColour = pColour[k];
				pTitle = $.trim(((p.title).toLowerCase()).replace(pColour[k], "").replace(p.vendor.toLowerCase(), ""));
			}
		}



		//change the "Selected color" text based on the first variant
		$("#variant-selected-color").text("");
		if (p.options[0].values[0] !== 'Default Title') {
			$("#variant-selected-color").text(pSelectedColour.toUpperCase());
		}

		$("#product-full-details-link").attr("href", p.url);

		$("#quick-shop-name").text(pTitle);

		//set iniital product price
		$("#quick-shop-price").html(setPrice(p));

		var isHandbag = false;

		var prodType = p.type.toLowerCase();

		if ((prodType.indexOf("hand") !== -1 && prodType.indexOf("bag") !== -1) || prodType.indexOf("handbag") !== -1) {
			isHandbag = true;
		} else {
			isHandbag = false;
		}

		if (!isHandbag) {
			outputOptionTags(p.options);
		}

		outputVariantId(p.variants);

		var siteUrl = window.location.protocol + "//" + window.location.host + "/";

		var colourVariantHex = [];

		for(let j = 0; j < p.tags.length; j++) {
			if(p.tags[j].indexOf("#") > -1) {
				colourVariantHex.push(p.tags[j]);
			}
		}
		
		if(pColour.length === 1) {
			$("#quick-shop-colour-variants").append("<a href='#' class='variant-colour-swatch selected' data-base-colour='"+ pColour[0] +"' data-color-name='' data-variant-colour='" + p.handle + "' style='background:"+colourVariantHex[0]+"'><p class='sr-only'>"+p.title+"</p></a>");
		}


		thumbnailSlickSettings.slidesToShow = p.images.length;


		setTimeout(function () {

			$('#variant-large-image-container').off('init').on('init', function (slick) {
					$('#variant-large-image-container').css("opacity", 1);
				})
				.slick(largeImageSlickSettings);


			$("#thumbnailContainer").slick(thumbnailSlickSettings);
			slickCheck = true;
		}, 400);




		if (window.innerWidth > 768) {
			$("#variant-large-image-container img").each(function () {
				//new Drift(this, options);
			});
		}

		disableUnavailableOptions(p);

		switchIdSelector();

		//$(".selector-width input").first().trigger("click");


		$("button[type='submit']").off('click').on("click", function (e) {

			if ((($(".selector-width input:checked").length < 1) || ($(".selector-size input:checked").length < 1)) && isHandbag === false) {
				e.preventDefault();
				var missingInput = '';
				if ($(".selector-width input:checked").length < 1) {
					missingInput = 'width';
				} else {
					missingInput = 'size';
				}
				$("#selection-error").text("Please select a " + missingInput + ".");
			} else {

				$("#selection-error").text("");
			}
		});
	}


	function clearFields() {
		$("#hover-zoom").empty();
		$(".ajaxified-cart-feedback").text("");
		$('#quick-shop-options').empty();
		$('#quick-shop-variant-ids').empty();
		$("#quick-shop-main-image").attr({
			'src': '',
			'data-zoom': ''
		});
		$("#Quantity").empty();
		$("#selection-error").text("");

		$("#script-prod-json").remove();

		if (slickCheck) {
			$("#variant-large-image-container").slick('unslick');
			$("#thumbnailContainer").slick('unslick');
			slickCheck = false;
		}

		$("#variant-large-image-container").empty();
		$("#thumbnailContainer").empty();
	}

	function resetStoredColourVariantInfo() {
		Object.keys(storedColourVariantInfo).forEach(function (k) {
			delete storedColourVariantInfo[k]
		});
		$("#quick-shop-colour-variants").empty();
	}

	function getColourContent(selectedColour) {

		var selectedColourObj = storedColourVariantInfo[selectedColour];

		clearFields();

		buildModalInfo(selectedColourObj);

	}

	//get the right id for the hidden select option so it adds the correct variant to the cart
	function switchIdSelector() {
		$('.variant-selector-radio input').on('change', function () {
			$("#selection-error").text("");
			var selected = [];
			var selectedOption = '';
			var getVariantId;

			$('.variant-selector-radio input:checked').each(function () {
				selected.push($(this).attr('value'));
			});
			selectedOption = selected.join(" / ");

			$("#quick-shop-variant-ids option").filter(function () {
				if ($(this).data('variant-name') == selectedOption) {
					getVariantId = $(this).val();
				}
			});

			$("#quick-shop-variant-ids").val(getVariantId);


			var variantSelectedInfo = null;

			for(var i = 0; i < currentProduct.variants.length; i++) {
				if(currentProduct.variants[i].title === selectedOption) {					
					variantSelectedInfo = currentProduct.variants[i];
				}
			}

			if(variantSelectedInfo !== null) {
				$("#quick-shop-price").html(setPrice(variantSelectedInfo));
			}
		});
	}

	function resetFields() {
		$("#modal-content").fadeOut("fast");
		$("#quick-shop-modal").fadeOut("fast");
		$("body").css("overflow", "auto");

		clearFields();

		$("#quick-shop-colour-variants").empty();
		hasColourVariantImages = false;
		variantPriceRange = false;
		priceDiff = false;
		currentProductPrice = 0;
		prevProductPrice = 0;
		smallestPrice = 0;
		compareAtPrice = 0;

		$(document).off('keyup.escCloseModal');
	}

	$(document).ready(function () {
		//show and hide the Quick Shop button on hover for the product
		if (window.innerWidth > 768) {
			$(".product").hover(function () {
				$(this).find(".quick-shop-container").css("opacity", 1);
			}, function () {
				$(this).find(".quick-shop-container").css("opacity", 0);
			});
		}

		//Modal toggle
		$("#modal-close").click(function () {
			resetFields();

		});


		//Quick Shop Functionality
		$('.quick-shop').off('click').on('click', function () {

			var productInfo = $(this).data('productInfo');
			var productColourHandles = $(this).data('productOtherColourHandles');
			var productColourHandlesArray;

			if (productColourHandles) {
				productColourHandlesArray = productColourHandles.split(" ");
			} else {
				productColourHandlesArray = [];
			}


			//get product data info
			jQuery.getJSON('/products/' + productInfo + '.js', function (p) {

				$("body").css("overflow", "hidden");

				resetStoredColourVariantInfo();

				currentProduct = p;

				var pColourHandle = p.handle;

				storedColourVariantInfo[p.handle] = p;

				var colourVariantImages = [];

				productColourHandlesArray = productColourHandlesArray.filter(function (e) {
					return String(e).trim();
				});


				if (productColourHandlesArray.length > 1) {
					for (var z = 0; z < productColourHandlesArray.length; z++) {

						jQuery.getJSON('/products/' + productColourHandlesArray[z] + '.js', function (c) {
							if (c.available == true) {
								var cHex = getProdHex(c.tags);
								var cColourName = getProdColourName(c.tags, c.title);

								var selectedClass = c.handle === p.handle ? 'selected' : '';

								$("#quick-shop-colour-variants").append("<a href='#' class='variant-colour-swatch "+selectedClass+"' data-base-colour='' data-color-name='"+cColourName+"' data-variant-colour='" + c.handle + "' style='background:"+cHex+"'><p class='sr-only'>"+c.title+"</p></a>");

								storedColourVariantInfo[c.handle] = c;

								setTimeout(function() {
									switchColourNames();
								}, 0);
							}
						});
					}
				}
				$("#quick-shop-modal").fadeIn("fast");

				setTimeout(function () {
                    buildModalInfo(p);
                    
                    if($(".selector-width input:not([disabled])").length === 1) {
                        $(".selector-width input:not([disabled])").attr('checked', true);
                      }

					//show the modal and add the overlay
					$("#modal-content").fadeIn("fast");
				}, 300);


				setTimeout(function () {
					if ($("#quick-shop-colour-variants a").length > 1) {
						$("#quick-shop-colour-variants a").off().on("click", function (e) {
							e.preventDefault();
							$('#variant-large-image-container').css("opacity", 0);
							var selectedColour = $(this).data("variant-colour");
							
							$("#quick-shop-colour-variants a").removeClass("selected");
							$(this).addClass("selected");

							getColourContent(selectedColour);
						});
					} else {
						$("#quick-shop-colour-variants a").off().on("click", function (e) {
							e.preventDefault();
						});
					}

				}, 500);


				$(document).on('keyup.escCloseModal', function (e) {
					if (e.keyCode === 27) {
						resetFields();
					}
				});
			});
		});
	});
};